import { PadLeftZero } from "./number";

let moment = require("moment");

export function GetShortTimeFromTimestamp(timestamp) {
  return moment(timestamp.seconds * 1000).format("hh:mm A");
}

function GetValue(h, m, meridien) {
  if (12 === h) {
    h = 0;
  }

  if ("PM" === meridien) {
    h += 12;
  }

  return h * 100 + m;
}

export function GetTime(h, m, meridien) {
  return {
    text: `${PadLeftZero(h)}:${PadLeftZero(m)} ${meridien}`,
    value: GetValue(h, m, meridien),
  };
}

export function GetTimeFromValue(value) {
  let m = value % 100;
  let h = (value - m) / 100;
  let meridien = h < 12 ? "AM" : "PM";

  h = h % 12 || 12;

  return {
    text: `${PadLeftZero(h)}:${PadLeftZero(m)} ${meridien}`,
    value: GetValue(h, m, meridien),
  };
}

export function MergeDateAndTime(date, time) {
  var timeSplit = time.split(":");
  date.setHours(timeSplit[0]);
  date.setMinutes(timeSplit[1]);
  date.setSeconds(timeSplit[2]);

  return new Date(date.getTime());
}

export function DisplayAmpmTime(time) {
  if (time) {
    var timeString = `${time}:00`;
    var H = +timeString.substr(0, 2);
    var h = H % 12 || 12;
    var ampm = H < 12 ? " AM" : " PM";
    return h + timeString.substr(2, 3) + ampm;
  }

  return "00:00";
}

export function GetTimeFromDate(date) {
  return GetTimeFromValue(date.getHours() * 100 + date.getMinutes());
}

export function GetTimeFromTimestamp(timestamp) {
  return moment(timestamp.seconds * 1000).format("hh:mm:ss A");
}

export function GetTimeFromTimestampService(timestamp) {
  return moment(timestamp.seconds * 1000).format("hh:mm A");
}

export function GetSlotCompare(timestamp) {
  return new Date(timestamp.seconds * 1000);
}
